module.exports = {
    apiKey: "AIzaSyBenyORXijGYAZM6H2rFkX0QdFwFwzelTo",
    authDomain: "afya-staging.firebaseapp.com",
    databaseURL: "https://afya-staging.firebaseio.com",
    projectId: "afya-staging",
    storageBucket: "afya-staging.appspot.com",
    messagingSenderId: "878684835542",
    appId: "1:878684835542:web:9aea2943a425e6e70e0377",
    measurementId: "G-5ZYGC4H1C3"
  };